import { render, staticRenderFns } from "./FhSnackbar.vue?vue&type=template&id=db64945c&scoped=true&"
import script from "./FhSnackbar.vue?vue&type=script&lang=js&"
export * from "./FhSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./FhSnackbar.vue?vue&type=style&index=0&id=db64945c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db64945c",
  null
  
)

export default component.exports